import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DocumentEncryptionProvider } from './contexts/DocumentEncryptionContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { CssBaseline } from '@mui/material';
import App from './App';
import './index.css';

// Detect browser and add class to html for CSS zoom scaling
// Edge and Chrome render content at different sizes on the same display settings
const isEdge = /Edg\//.test(navigator.userAgent);
const isChrome = /Chrome\//.test(navigator.userAgent) && !isEdge; // Edge also has Chrome in UA

if (isEdge) {
  document.documentElement.classList.add('browser-edge');
} else if (isChrome) {
  document.documentElement.classList.add('browser-chrome');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

document.title = `${process.env.COMPANY_NAME || 'Nautilus Dynamics'} - Workspace`;

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <DocumentEncryptionProvider>
          <ThemeProvider>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </DocumentEncryptionProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);